import { useMutation, useQueryClient } from '@tanstack/react-query'
import { uploadAgendaImageService } from '@/services/agendas'
import { AGENDAS_QUERY_KEY } from '@/hooks/agendas/useAgendas'
import { agendaDetailsQueryKey } from '@/hooks/agendas/useAgendaDetails'

export const useUploadAgendaImage = (agendaId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (file: File) => uploadAgendaImageService(agendaId, file),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: AGENDAS_QUERY_KEY })
      queryClient.invalidateQueries({ queryKey: agendaDetailsQueryKey(agendaId) })
    },
  })
}
